import React from 'react';
import { useSidebar } from '../../provider/sidebar/sidebar-context';
import styles from './component-container.module.css';

type ComponentContainerProps = {
	customBackground?: boolean;
};

const ComponentContainer: React.FC<ComponentContainerProps> = (props) => {
	const { hideSidebar } = useSidebar();

	return (
		<div>
			<div className="cyber-backdrop"></div>

			<div
				className={`cyber-main with-sidenav ${props.customBackground ? styles['component-container'] : ''}`}
				onClick={hideSidebar}
			>
				<div className={'cyber-spacer section'}></div>
				<div className="cyber-container">{props.children}</div>
			</div>
		</div>
	);
};

export default ComponentContainer;
